<div class="mat-body-2">
	<h1>Regatta-Erfolge der YSTM-Segler</h1>
	<p>Regatta-Segeln liegt in der DNA des YSTM. Einige unserer Mitglieder 
		konnten sich auf der Regatta-Bahn immer wieder behaupten, z.B.:</p>

	<mat-toolbar color="primary">2025</mat-toolbar>
	<mat-card>
		<mat-card-content>
			<p>Im Jahr 2025</p>
			<p>Internationale Deutsche Meisterschaft der <b>P-Boote</b> (15qm Jollenkreuzer):</p>
			<ul>
				<li>Meister: Uwe Lätzsch (YSTM), Marc Romberg (PYC).</li>
				<li>Vize-Meister: Dieter Bröer (YSTM), Andreas Bröer (YSTM).</li>
			</ul>
			<p>Junioren WM der 49er: </p>
			<ul>
				<li>9. Platz: Constantin Streicher (YSTM), Cornelius Streicher (YSTM).</li>
			</ul>
			<!-- <p>90. Nordsee-Woche, Rund-Helgoland, Wertung DSV Geschwader-Fahrt: </p>
			<ul>
				<li>4. Platz: Ulrike Grüneberg (YSTM), Lutz Grüneberg (YSTM), Alexander von Berg (SCM).</li>
			</ul> -->
		</mat-card-content>
	</mat-card>
	<mat-toolbar color="primary">2024</mat-toolbar>
	<mat-card>
		<mat-card-content>
			<p>Im Jahr 2024</p>
			<p>Internationale Deutsche Meisterschaft der <b>P-Boote</b> (15qm Jollenkreuzer):</p>
			<ul>
				<li>Vize-Meister: Uwe Lätzsch (YSTM), Marc Romberg (PYC).</li>
			</ul>
		</mat-card-content>
	</mat-card>
	<mat-toolbar color="primary">2023</mat-toolbar>
	<mat-card>
		<mat-card-content>
			<p>Im Jahr 2023</p>
			<p>Internationale Deutsche Meisterschaft der <b>P-Boote</b> (15qm Jollenkreuzer):</p>
			<ul>
				<li>Meister: Uwe Lätzsch (YSTM), Marc Romberg (PYC).</li>
			</ul>
		</mat-card-content>
	</mat-card>
	<mat-toolbar color="primary">2022</mat-toolbar>
	<mat-card>
		<mat-card-content>
			<p>Im Jahr 2022</p>
			<p>Internationale Deutsche Meisterschaft der <b>P-Boote</b> (15qm Jollenkreuzer):</p>
			<ul>
				<li>Vize-Meister: Uwe Lätzsch (YSTM), Marc Romberg (PYC).</li>
			</ul>
		</mat-card-content>
	</mat-card>
	<mat-toolbar color="primary">2021</mat-toolbar>
	<mat-card>
		<mat-card-content>
			<p>Im Jahr 2021</p>
			<p>Internationale Deutsche Meisterschaft der <b>P-Boote</b> (15qm Jollenkreuzer):</p>
			<ul>
				<li>Vize-Meister: Uwe Lätzsch (YSTM), Marc Romberg (PYC).</li>
				<!-- <li>Meister B-Boot: Dirk Forstmeyer (SVG), Lutz Grüneberg (YSTM).</li> -->
			</ul>
		</mat-card-content>
	</mat-card>

</div>
